import { ResponsiveContainer, ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from "recharts";
import { TrendingUp } from "lucide-react";
import { Section } from "../dc";
import { C, trendFor, GRAIN } from "./data";

export const LeadsTrend = ({ period }) => (
  <Section title="Leads, actions & revenue" sub={`${period} · ${GRAIN[period]}. Leads in vs actioned vs won, with first-90-day revenue from won leads.`} icon={TrendingUp} testid="lx-trend">
    <div style={{ height: 280 }}>
      <ResponsiveContainer>
        <ComposedChart data={trendFor(period)} margin={{ top: 8, right: 8, left: -8, bottom: 0 }}>
          <CartesianGrid vertical={false} stroke="#E6EEEF" />
          <XAxis dataKey="m" tick={{ fontSize: 11 }} minTickGap={8} />
          <YAxis yAxisId="n" tick={{ fontSize: 11 }} allowDecimals={false} />
          <YAxis yAxisId="r" orientation="right" tick={{ fontSize: 11 }} tickFormatter={(v) => `$${Math.round(v / 1000)}k`} />
          <Tooltip formatter={(v, n) => (n === "Revenue (90d)" ? `$${v.toLocaleString()}` : v)} />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          <Bar yAxisId="n" dataKey="in" name="Leads in" fill={C.soft} radius={[3, 3, 0, 0]} />
          <Bar yAxisId="n" dataKey="actioned" name="Actioned" fill={C.fill} radius={[3, 3, 0, 0]} />
          <Bar yAxisId="n" dataKey="won" name="Won" fill={C.teal} radius={[3, 3, 0, 0]} />
          <Line yAxisId="r" dataKey="revenue" name="Revenue (90d)" stroke={C.ink} strokeWidth={2} dot={{ r: 2 }} />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  </Section>
);
